/* Silk Theme — Lenis smooth scroll initialization
   Requires: lenis.js in this directory (IIFE, sets globalThis.Lenis)
   Attaches to <html>, respects prefers-reduced-motion.
   Falls back to native scroll if Lenis global is missing. */
(function() {
    'use strict';

    // Skip entirely when user prefers reduced motion
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    // Guard: Lenis must be available (set by lenis.js IIFE)
    if (typeof Lenis === 'undefined') return;

    var lenis = new Lenis({
        lerp: 0.165,
        wheelMultiplier: 1.25,
        touchMultiplier: 1.5,
        orientation: 'vertical',
        gestureOrientation: 'vertical',
        smoothWheel: true
    });

    // Sync Lenis with requestAnimationFrame
    function raf(time) {
        lenis.raf(time);
        requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);

    // Expose instance for other scripts (e.g. mobile menu overflow toggle)
    window.__silk_lenis = lenis;
})();
